import { useState, useEffect } from "react"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  FormFeedback,
  Modal
} from "reactstrap"

// ** Third Party Components
import * as yup from "yup"
import { useFormik } from "formik"
import Flatpickr from "react-flatpickr"
import { Plus, Minus } from "react-feather"

const ViajeSeguroForm = (props) => {
  // ** State

  const datosAsesoria = {
    origen: "",
    destino: "",
    fechaSalida: "",
    fechaRegreso: "",
    numPasajeros: 0,
    edades: []
  }

  function initialValues() {
    if (props.accion === 1) {
      return datosAsesoria
    } else {
      return props.data
    }
  }

  // ** State
  const [numPasajeros, setNumPasajeros] = useState(
    props.data.numPasajeros !== "" && props.data.hasOwnProperty("numPasajeros")
      ? parseInt(props.data.numPasajeros)
      : 0
  )

  function validationSchema() {
    return {
      // origen: yup.string().required("Este campo es requerido."),
      // destino: yup.string().required("Este campo es requerido."),
      // numPasajeros: yup.number().min(1).required("Este campo es requerido."),
      // edadPasajero: yup.number().required("Este campo es requerido.")
    }
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: yup.object(validationSchema()),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "personal",
        nombre: "Viajar seguro",
        slug: "viajar-seguro"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  useEffect(() => {
    formik.setFieldValue("numPasajeros", numPasajeros)
    // Actualiza arreglo de edades del formik
    if (numPasajeros > formik.values.edades.length) {
      formik.setFieldValue("edades", [...formik.values.edades, 0])
    } else {
      // Decremento numPasajeros
      const nuevoArray = [...formik.values.edades]
      nuevoArray.splice(numPasajeros, 1)
      formik.setFieldValue("edades", nuevoArray)
    }
    return () => {}
  }, [numPasajeros])

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Viaje seguro</h1>
      <div className="mb-1">
        <Label className="form-label" htmlFor="origen">
          Origen
        </Label>
        <Input
          placeholder="Ingresa el origen"
          id="origen"
          type="text"
          value={formik.values.origen}
          invalid={formik.errors.origen && true}
          onChange={(e) => {
            formik.setFieldValue("origen", e.target.value)
          }}
        />
        {formik.errors.origen && (
          <FormFeedback>{formik.errors.origen}</FormFeedback>
        )}
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="destino">
          Destino
        </Label>
        <Input
          placeholder="Ingresa el destino"
          id="destino"
          type="text"
          value={formik.values.destino}
          invalid={formik.errors.destino && true}
          onChange={(e) => {
            formik.setFieldValue("destino", e.target.value)
          }}
        />
        {formik.errors.destino && (
          <FormFeedback>{formik.errors.destino}</FormFeedback>
        )}
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="inicio">
          Salida
        </Label>
        <Flatpickr
          className="form-control cursor-pointer"
          options={{ dateFormat: "d/m/Y", defaultDate: "today" }}
          value={formik.values.fechaSalida}
          onChange={(_selectedDates, dateString) => {
            formik.setFieldValue("fechaSalida", dateString)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="inicio">
          Regreso
        </Label>
        <Flatpickr
          className="form-control cursor-pointer"
          options={{ dateFormat: "d/m/Y", defaultDate: "today" }}
          value={formik.values.fechaRegreso}
          onChange={(_selectedDates, dateString) => {
            formik.setFieldValue("fechaRegreso", dateString)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="numPasajeros">
          Cantidad de pasajeros
        </Label>
        <div className="d-flex">
          <Button
            className="round"
            color="success"
            size="sm"
            onClick={
              numPasajeros > 0
                ? () => {
                    setNumPasajeros(numPasajeros - 1)
                  }
                : () => {
                    setNumPasajeros(numPasajeros)
                  }
            }
          >
            {" "}
            <Minus />{" "}
          </Button>
          <Input
            onChange={(e) => {
              formik.setFieldValue("numPasajeros", e.target.value)
            }}
            value={formik.values.numPasajeros}
            style={{ width: "70px" }}
            className="mx-1 text-center text-dark"
            type="number"
          />
          <Button
            className="round"
            color="success"
            size="sm"
            onClick={() => {
              setNumPasajeros(numPasajeros + 1)
            }}
          >
            {" "}
            <Plus />{" "}
          </Button>
        </div>
      </div>

      {formik.values.edades.length > 0 ? (
        <Label className="form-label my-2">
          Ingrese las edades de los pasajeros
        </Label>
      ) : (
        ""
      )}

      {formik.values.edades.length > 0 &&
        formik.values.edades.map((_edad, index) => (
          <div className="mb-1" key={index}>
            <Label className="form-label" htmlFor="edadPasajero">
              Edad pasajero {index + 1}
            </Label>
            <Input
              className="w-25"
              id="edadPasajero"
              type="number"
              placeholder="Ingrese edad"
              value={formik.values.edades[index]}
              onChange={(e) => {
                formik.setFieldValue(`edades[${index}]`, e.target.value)
              }}
            />
          </div>
        ))}

      <div className=" mb-1 d-flex justify-content-end">
        <Button className="m-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default ViajeSeguroForm
